<template lang="html">
  <div class="row encounter-slide">
    <div v-if="treatment_plan" class="tp-title col-12">
      <h5><strong>{{ treatment_plan.Heading }}</strong></h5>
      <p><em>
        treatment plan prepared 
        <span v-if="pat_name">for {{ pat_name }}</span> 
        <span v-if="treatment_plan.SecDateTEdit"> on {{ treatment_plan.SecDateTEdit | prettyDateShortFromDT }}</span>
      </em></p>
    </div> <!-- /.tp-title -->

    <div class="slide-body col-12">
      <h1 class="text-center">Understand What's Happening</h1>
      <!-- TODO: add buttons to show health teeth & gums example images -->
      <div class="row row-btns">
        <div class="col-6">
          <button @click="activePhoto=0" class="btn btn-example btn-lg btn-icon-left btn-light-outline btn-no-animation d-flex align-items-center justify-content-center"><i class="fas fa-tooth"></i><span>Healthy Teeth</span></button>
        </div> <!-- /.col -->
        <div class="col-6">
          <button @click="activePhoto=1" class="btn btn-example btn-lg btn-icon-left btn-light-outline btn-no-animation d-flex align-items-center justify-content-center"><i class="fas fa-teeth"></i><span>Healthy Gums</span></button>
        </div> <!-- /.col -->
      </div> <!-- /.row -->
      <image-gallery v-if="encounterData"></image-gallery>
      <hr class="hr-dark-color" />
      <p class="text-center"><button @click.prevent="markSlideAndForward" class="btn btn-green btn-lg">Yes, I Understand<i class="fas fa-angle-right fa-fw"></i></button></p>
    </div> <!-- /.slide-body -->

    <div v-if="examplePhotos[activePhoto]" class="modal modal-app" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-body text-center">
            <button class="btn btn-icon btn-close" @click="activePhoto=null"><i class="fas fa-times"></i></button>
            <div class="photo-scroll">
              <img v-if="examplePhotos[activePhoto]" :src="examplePhotos[activePhoto].path" alt="photo placeholder" class="img-fluid img-placeholder">
            </div>
            <div class="modal-caption-container">
              <p v-if="examplePhotos[activePhoto].caption"><span class="caption">{{ examplePhotos[activePhoto].caption }}</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="examplePhotos[activePhoto]" class="modal-backdrop"></div>

  </div> <!-- /.encounter-slide -->
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import ImageGallery from '../components/ImageGallery.vue'

export default {
  props: ['encounterData'],
  components: {
    ImageGallery,
  },
  data() {
    return {
      treatPlanData: null,
      activePhoto: null,
      examplePhotos: [
        {path: '../assets/img/example-healthy-teeth.jpg', caption: 'Healthy Teeth Example'},
        {path: '../assets/img/example-healthy-gums.jpg', caption: 'Healthy Gums Example'},
      ],
    };
  },
  computed: {
    ...mapGetters(['user', 'user_props', 'custom_claims', 'appointment', 'encounter','treatment_plan', 'pat_num', 'pat_name']),
  },
  watch: {
    
  },
  methods: {
    markSlideAndForward() {
      // this.$emit('update-encounter-data', {
      //   slides_completed: [
      //     ...this.encounterData.slides_completed,
      //     this.$route.name,
      //   ],
      // });
      this.$emit('forward')
    },
  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

h1 {
  margin-bottom: 50px;
}
.tp-title {
  text-align: center;
  padding: 20px;
  border-bottom: 1px solid @dark-color;
  margin-bottom: 30px;

  h5,p {
    margin: 0;
  }
}
.encounter-slide {
  padding: 0;
}
.slide-body {
  padding: 0 30px 30px;
}
.row-btns {
  margin: 0 0 20px 0;
}
.btn-example {
  width: 100%;
  vertical-align: middle;
  border-width: 3px !important;
  border-radius: 5px;
  font-size: 18px !important;

  .fas {
    font-size: 30px;
  }
  &:hover {
    background-color: @major-color;
  }
}
.img-placeholder {
  width: 100%;
  height: 400px;
  display: block;
  background-color: @dim-color;
  text-align: center;
}
// modal overrides
.modal-body .btn-close {
  // right: 35px;
  background-color: fadeout(@light-color,50%);
}
.modal-caption-container {
  // background-color: @light-color;
  padding: 20px;

  p {
    margin: 0;
  }
}
hr {
  margin: 0 0 20px;
}
</style>
